// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DailyUsage } from "./DailyUsage";
import {
  DailyUsageFromJSON,
  DailyUsageFromJSONTyped,
  DailyUsageToJSON,
  DailyUsageToJSONTyped,
} from "./DailyUsage";

/**
 *
 * @export
 * @interface PageDailyUsage
 */
export interface PageDailyUsage {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<DailyUsage>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageDailyUsage interface.
 */
export function instanceOfPageDailyUsage(value: object): value is PageDailyUsage {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageDailyUsageFromJSON(json: any): PageDailyUsage {
  return PageDailyUsageFromJSONTyped(json, false);
}

export function PageDailyUsageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageDailyUsage {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(DailyUsageFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageDailyUsageToJSON(json: any): PageDailyUsage {
  return PageDailyUsageToJSONTyped(json, false);
}

export function PageDailyUsageToJSONTyped(
  value?: PageDailyUsage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(DailyUsageToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
